module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Pembayaran',
          to: {
            path: '/produk'
          },
          exact: true,
        },
        {
          text: 'Paket',
          to: {
            path: '/produk'
          },
          exact: true,
        },
        {
          text: !_vm.$route.query.id ? 'Buat Paket' : 'Update Paket'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Paket Baru" : "Ubah Paket") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    attrs: {
      "flat": ""
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-card', {
    staticClass: "border-bottom-divider rounded-tl pa-0",
    attrs: {
      "flat": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    key: _vm.keyimg,
    attrs: {
      "src": _vm.url ?
        _vm.url :
        require('@/assets/img/unavailable.png')
    }
  })])])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 my-2"
  }, [_c('v-btn', {
    staticClass: "pa-0 mt-5 font-weight-bold",
    attrs: {
      "block": "",
      "color": "success",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.uploader.click()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1"
  }, [_vm._v("mdi-file-upload")]), _vm._v("\n                            Upload\n                        ")], 1), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Ukuran gambar 400 x 500\n                    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-caption pa-0 d-flex justify-center"
  }, [_vm._v("\n                        Maximum size is 300 KB\n                    ")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    Nama "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    staticClass: "pb-2",
    attrs: {
      "placeholder": "Nama Paket",
      "dense": "",
      "maxLength": "100",
      "hint": _vm.data.package_name ?
        _vm.data.package_name.length +
        '/100' :
        '0/100',
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.package_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_name", $$v)
      },
      expression: "data.package_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    Deskripsi paket\n                                    "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "placeholder": "Deskripsi paket",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.package_description),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_description", $$v)
      },
      expression: "data.package_description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    Fitur "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.feature_description),
      callback: function($$v) {
        _vm.$set(_vm.data, "feature_description", $$v)
      },
      expression: "data.feature_description"
    }
  }), _vm._v(" "), (_vm.data.feature_description) ? _c('div', {
    staticClass: "mt-1 text-right grey--text"
  }, [_vm._v("\n                                    " + _vm._s(_vm.characterCounter(
    _vm.data.feature_description
  )) + "\n                                    karakter\n                                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0 mt-6"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                                Harga Normal\n                                            ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prefix": "Rp",
      "dense": "",
      "outlined": "",
      "separator": ",",
      "value": _vm.data.normal_price =
        Number(
          _vm.data.normal_price
        )
    },
    model: {
      value: (_vm.data.normal_price),
      callback: function($$v) {
        _vm.$set(_vm.data, "normal_price", $$v)
      },
      expression: "data.normal_price"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                                Harga Asli\n                                                "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "Harga Asli",
      "prefix": "Rp",
      "dense": "",
      "outlined": "",
      "separator": ",",
      "value": _vm.data.actual_price =
        Number(
          _vm.data.actual_price
        )
    },
    model: {
      value: (_vm.data.actual_price),
      callback: function($$v) {
        _vm.$set(_vm.data, "actual_price", $$v)
      },
      expression: "data.actual_price"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    Potongan Referral\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "prefix": "Rp",
      "dense": "",
      "outlined": "",
      "placeholder": "Potongan Referral",
      "separator": ",",
      "value": _vm.data.referral_discount = Number(
        _vm.data.referral_discount
      )
    },
    model: {
      value: (_vm.data.referral_discount),
      callback: function($$v) {
        _vm.$set(_vm.data, "referral_discount", $$v)
      },
      expression: "data.referral_discount"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    Diskon\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "Diskon Paket",
      "prefix": "%",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.discount),
      callback: function($$v) {
        _vm.$set(_vm.data, "discount", $$v)
      },
      expression: "data.discount"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-8"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "-12px"
    }
  }, [_c('v-checkbox', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "label": "Gunakan waktu diskon berakhir",
      "false-value": false,
      "true-value": true,
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.is_discount_exp),
      callback: function($$v) {
        _vm.is_discount_exp = $$v
      },
      expression: "is_discount_exp"
    }
  })], 1), _vm._v(" "), (_vm.is_discount_exp) ? _c('div', [_c('div', {
    staticClass: "font-weight-bold font-size-14 pb-1 pt-3 black--text"
  }, [_vm._v("\n                                    Diskon Berakhir\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": true,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "readonly": "",
            "dense": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (
              _vm.date_discount_exp_time
            ),
            callback: function($$v) {
              _vm.date_discount_exp_time
                = $$v
            },
            expression: "\n                                                            date_discount_exp_time\n                                                        "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 4188778303)
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "min": new Date()
        .toISOString()
        .slice(0, 10),
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (
        _vm.date_discount_exp_time
      ),
      callback: function($$v) {
        _vm.date_discount_exp_time
          = $$v
      },
      expression: "\n                                                        date_discount_exp_time\n                                                    "
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          staticStyle: {
            "margin-top": "-11px"
          },
          attrs: {
            "outlined": "",
            "placeholder": "Waktu",
            "append-icon": "mdi-clock-time-four-outline",
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: (
              _vm.expiredTime.value
            ),
            callback: function($$v) {
              _vm.$set(_vm.expiredTime, "value", $$v)
            },
            expression: "\n                                                            expiredTime.value\n                                                        "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 3322919180),
    model: {
      value: (_vm.expiredTime.option),
      callback: function($$v) {
        _vm.$set(_vm.expiredTime, "option", $$v)
      },
      expression: "expiredTime.option"
    }
  }, [_vm._v(" "), (
    _vm.expiredTime.option
  ) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "change": function($event) {
        _vm.expiredTime.option = false
      }
    },
    model: {
      value: (
        _vm.expiredTime.value
      ),
      callback: function($$v) {
        _vm.$set(_vm.expiredTime, "value", $$v)
      },
      expression: "\n                                                        expiredTime.value\n                                                    "
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    Tipe "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "outlined": "",
      "placeholder": "Pilih Tipe",
      "disabled": !!_vm.queryId,
      "dense": "",
      "items": [{
          text: 'PACKAGES',
          value: 'PACKAGES',
        },
        {
          text: 'ADDON',
          value: 'ADDON'
        } ]
    },
    on: {
      "change": function($event) {
        ((_vm.data.package_type = ''),
          (_vm.data.expiry_date = ''),
          (_vm.data.start_date = ''),
          (_vm.data.addon_value = 0))
      }
    },
    model: {
      value: (_vm.data.package_category),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_category", $$v)
      },
      expression: "data.package_category"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    Jenis "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "outlined": "",
      "placeholder": "Pilih Jenis",
      "disabled": !!_vm.queryId,
      "dense": "",
      "value": _vm.data.package_type =
        _vm.data.package_category == 'ADDON' ?
        'QUOTA' :
        _vm.data.package_type,
      "items": _vm.data.package_category == 'ADDON' ?
        [{
          text: 'QUOTA',
          value: 'QUOTA',
        } ] :
        [{
            text: 'MONTHLY',
            value: 'MONTHLY',
          },
          {
            text: 'ANNUALLY',
            value: 'ANNUALLY',
          },
          {
            text: '3 MONTH',
            value: 'THREE_MONTH',
          },
          {
            text: '6 MONTH',
            value: 'SIX_MONTH',
          },
          {
            text: '9 MONTH',
            value: 'NINE_MONTH',
          },
          {
            text: 'WEEKLY',
            value: 'WEEKLY',
          } ]
    },
    on: {
      "change": function($event) {
        ((_vm.data.expiry_date = ''),
          (_vm.data.start_date = ''))
      }
    },
    model: {
      value: (_vm.data.package_type),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_type", $$v)
      },
      expression: "data.package_type"
    }
  })], 1)], 1), _vm._v(" "), (_vm.data.package_category == 'PACKAGES') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    Kuota Konsul\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "placeholder": "Kuota Konsul",
      "dense": "",
      "outlined": ""
    },
    model: {
      value: (_vm.data.consul_session),
      callback: function($$v) {
        _vm.$set(_vm.data, "consul_session", $$v)
      },
      expression: "data.consul_session"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.package_category !== 'ADDON'),
      expression: "data.package_category !== 'ADDON'"
    }],
    staticClass: "pa-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                                Waktu Mulai\n                                                "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pl-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": true,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "disabled": _vm.queryId,
                "append-icon": "mdi-calendar",
                "placeholder": "Tanggal",
                "readonly": "",
                "dense": "",
                "outlined": ""
              },
              model: {
                value: (
                  _vm.data.start_date
                ),
                callback: function($$v) {
                  _vm.$set(_vm.data, "start_date", $$v)
                },
                expression: "\n                                                                        data.start_date\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }])
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "disabled": _vm.queryId,
      "min": new Date()
        .toISOString()
        .slice(
          0,
          10
        ),
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (
        _vm.data.start_date
      ),
      callback: function($$v) {
        _vm.$set(_vm.data, "start_date", $$v)
      },
      expression: "\n                                                                    data.start_date\n                                                                "
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                                Waktu Berakhir\n                                                "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("\n                                                    *\n                                                ")])]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": true,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
              attrs: {
                "disabled": _vm.queryId,
                "append-icon": "mdi-calendar",
                "placeholder": "Tanggal",
                "readonly": "",
                "dense": "",
                "outlined": ""
              },
              model: {
                value: (
                  _vm.data.expiry_date
                ),
                callback: function($$v) {
                  _vm.$set(_vm.data, "expiry_date", $$v)
                },
                expression: "\n                                                                        data.expiry_date\n                                                                    "
              }
            }, 'v-text-field',
            attrs, false),
          on
        ))]
      }
    }])
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "disabled": _vm.queryId,
      "min": new Date()
        .toISOString()
        .slice(
          0,
          10
        ),
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (
        _vm.data.expiry_date
      ),
      callback: function($$v) {
        _vm.$set(_vm.data, "expiry_date", $$v)
      },
      expression: "\n                                                                    data.expiry_date\n                                                                "
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.data.package_category !== 'ADDON') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2"
  }, [_vm._v("\n                                    Jenjang "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-radio-group', {
    staticStyle: {
      "margin-top": "-2px"
    },
    attrs: {
      "row": "",
      "disabled": !!_vm.queryId,
      "mandatory": ""
    },
    on: {
      "change": function($event) {
        _vm.data.package_grade = []
      }
    },
    model: {
      value: (_vm.data.package_level),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_level", $$v)
      },
      expression: "data.package_level"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "SD",
      "value": "SD",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "SMP",
      "value": "SMP",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "SMA",
      "value": "SMA",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.package_category !== 'ADDON') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2"
  }, [_vm._v("\n                                    Kelas "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [(_vm.data.package_level === 'SD') ? _c('v-radio-group', {
    attrs: {
      "row": "",
      "disabled": !!_vm.queryId
    },
    model: {
      value: (_vm.data.package_grade),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_grade", $$v)
      },
      expression: "data.package_grade"
    }
  }, _vm._l((6), function(i) {
    return _c('v-radio', {
      key: i,
      staticClass: "jenjang-selection",
      attrs: {
        "label": '' + i,
        "value": i,
        "active-class": "act-radio-btn"
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.package_level === 'SMP') ? _c('v-radio-group', {
    attrs: {
      "row": "",
      "disabled": !!_vm.queryId
    },
    model: {
      value: (_vm.data.package_grade),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_grade", $$v)
      },
      expression: "data.package_grade"
    }
  }, _vm._l((3), function(i) {
    return _c('v-radio', {
      key: i,
      staticClass: "jenjang-selection",
      attrs: {
        "label": '' + (i + 6),
        "value": i + 6,
        "active-class": "act-radio-btn"
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.data.package_level === 'SMA') ? _c('v-radio-group', {
    attrs: {
      "row": "",
      "disabled": !!_vm.queryId
    },
    model: {
      value: (_vm.data.package_grade),
      callback: function($$v) {
        _vm.$set(_vm.data, "package_grade", $$v)
      },
      expression: "data.package_grade"
    }
  }, _vm._l((3), function(i) {
    return _c('v-radio', {
      key: i,
      staticClass: "jenjang-selection",
      attrs: {
        "label": '' + (i + 9),
        "value": i + 9,
        "active-class": "act-radio-btn"
      }
    })
  }), 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.package_category == 'ADDON') ? _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    Jumlah Kuota\n                                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "outlined": ""
    },
    model: {
      value: (_vm.data.addon_value),
      callback: function($$v) {
        _vm.$set(_vm.data, "addon_value", $$v)
      },
      expression: "data.addon_value"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "font-weight-bold black--text font-size-14 pt-2"
  }, [_vm._v("\n                                Tampilkan Paket\n                            ")]), _vm._v(" "), _c('v-switch', {
    staticClass: "font-size-12",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "inset": "",
      "false-value": 0,
      "true-value": 1,
      "color": "success"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticClass: "font-size-14"
        }, [_vm._v("\n                                        " + _vm._s(_vm.data.is_show === 1 ?
          "Paket Ditampilkan" :
          "Paket Tidak Ditampilkan") + "\n                                    ")])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.data.is_show),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_show", $$v)
      },
      expression: "data.is_show"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text font-size-14 mt-8"
  }, [_vm._v("\n                            Pengaturan Lainnya\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex mt-1",
    staticStyle: {
      "gap": "20px",
      "padding-top": "-20px"
    }
  }, [_c('v-checkbox', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "false-value": false,
      "true-value": true,
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('span', {
          staticClass: "font-size-14 d-flex align-center"
        }, [_vm._v("\n                                        Paket Rekomendasi\n                                        "), _c('v-chip', {
          staticClass: "px-2 py-3 ml-1",
          staticStyle: {
            "color": "#0277bd"
          },
          attrs: {
            "x-small": "",
            "color": "#E1F5FE",
            "dark": ""
          }
        }, [_vm._v("\n                                            Untuk Skolla App\n                                        ")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.data.is_recommended),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_recommended", $$v)
      },
      expression: "data.is_recommended"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "label": "Paket untuk IOS",
      "false-value": 0,
      "true-value": 1,
      "outlined": ""
    },
    model: {
      value: (_vm.data.is_ios),
      callback: function($$v) {
        _vm.$set(_vm.data, "is_ios", $$v)
      },
      expression: "data.is_ios"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text font-size-14 mt-8 d-flex align-center"
  }, [_vm._v("\n                            Sorotan Produk\n\n                            "), _c('v-chip', {
    staticClass: "px-2 py-3 ml-1",
    staticStyle: {
      "color": "#00897b"
    },
    attrs: {
      "x-small": "",
      "color": "#E0F2F1",
      "dark": ""
    }
  }, [_vm._v("\n                                Untuk Web Purchase\n                            ")])], 1), _vm._v(" "), _c('div', [_c('v-radio-group', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.data.badge),
      callback: function($$v) {
        _vm.$set(_vm.data, "badge", $$v)
      },
      expression: "data.badge"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Rekomendasi",
      "value": "RECOMMENDED",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Pilihan Terbaik",
      "value": "BEST_VALUES",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "label": "Banyak Dibeli",
      "value": "MOST_PURCHASED",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.package_category === 'PACKAGES'),
      expression: "data.package_category === 'PACKAGES'"
    }],
    staticClass: "pa-0 mt-3",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pt-0 px-0 pb-6"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pt-2 pb-1"
  }, [_vm._v("\n                                    User Group\n                                ")]), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "pa-0",
    attrs: {
      "outlined": "",
      "items": _vm.userGroups,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "placeholder": "Pilih User Group",
      "dense": ""
    },
    model: {
      value: (_vm.data.user_group_id),
      callback: function($$v) {
        _vm.$set(_vm.data, "user_group_id", $$v)
      },
      expression: "data.user_group_id"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.package_category === 'PACKAGES'),
      expression: "data.package_category === 'PACKAGES'"
    }],
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold font-size-14 pb-2"
  }, [_vm._v("\n                                    User Scope\n                                ")]), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "custom-chips-spacing",
    attrs: {
      "items": _vm.app_scope,
      "item-text": "display_name",
      "item-value": "id",
      "placeholder": "Pilih App Scope",
      "outlined": "",
      "multiple": "",
      "dense": "",
      "disabled": _vm.data.package_category !==
        'PACKAGES' || !!_vm.queryId
    },
    model: {
      value: (_vm.data.app_scope),
      callback: function($$v) {
        _vm.$set(_vm.data, "app_scope", $$v)
      },
      expression: "data.app_scope"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.queryId),
      expression: "queryId"
    }],
    staticClass: "my-3",
    attrs: {
      "depressed": "",
      "block": "",
      "color": "blew white--text"
    },
    on: {
      "click": function($event) {
        return _vm.openDialogSequence()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("\n                                mdi-sort\n                            ")]), _vm._v("\n\n                            Atur Urutan Paket\n                        ")], 1), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (
        _vm.data.package_category === 'PACKAGES' &&
        _vm.liveclass_schedulled
      ),
      expression: "\n                                data.package_category === 'PACKAGES' &&\n                                liveclass_schedulled\n                            "
    }],
    staticClass: "px-0 pt-0 mt-7 ma-0 pb-8",
    attrs: {
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "font-weight-bold font-size-14"
  }, [_vm._v("\n                                Jadwal Kelas\n                                "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]), _vm._v(" "), _c('v-simple-table', {
    staticClass: "mb-5"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v("Deskripsi")]), _vm._v(" "), _c('td', [_vm._v("Threshold")]), _vm._v(" "), _c('td', [_vm._v("Mulai")]), _vm._v(" "), _c('td', [_vm._v("Berakhir")]), _vm._v(" "), _c('td', [_vm._v("Aksi")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tryouts), function(tryout, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n                                            " + _vm._s(tryout.id) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                                            " + _vm._s(tryout.desc) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                                            " + _vm._s(tryout.threshold) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                                            " + _vm._s(tryout.start_time) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                                            " + _vm._s(tryout.end_time) + "\n                                        ")]), _vm._v(" "), _c('td', [_c('v-btn', {
      staticClass: "pa-0 red--text",
      attrs: {
        "color": "lightred",
        "small": "",
        "depressed": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeTryoutFromGroup(
            _vm.group
          )
        }
      }
    }, [_vm._v("\n                                                Hapus\n                                            ")])], 1)])
  }), 0)]), _vm._v(" "), _c('app-jadwalkelaschooser', {
    on: {
      "selected": function($event) {
        return _vm.addTryoutIntoGroup($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-2 mt-5"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/produk'
        })
      }
    }
  }, [_vm._v("\n                                Batal\n                            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.upload()
      }
    }
  }, [_vm._v("\n                                Simpan\n                            ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "940px"
    },
    model: {
      value: (_vm.dialogPackageSequence),
      callback: function($$v) {
        _vm.dialogPackageSequence = $$v
      },
      expression: "dialogPackageSequence"
    }
  }, [(_vm.dialogPackageSequence) ? _c('dialog-package-sequence', {
    on: {
      "close": function($event) {
        _vm.dialogPackageSequence = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ebb826","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/ProdukForm.vue
// module id = 2006
// module chunks = 1